"use client";

import { useQuery } from "@tanstack/react-query";
import {
  TemplateFilter,
  TemplateTagsFilter,
  templateTagsFilterMetadata,
  typeWithTemplate,
} from "./constants";
import { TemplateMasonry } from "./template-masonry";
import { TemplateData } from "./templates-action";
import { apiClient } from "@/server/init";

export function TemplateRecommendations({ template }: { template: TemplateData }) {
  const filter = computeInitialFilter(template);

  // TODO: for now, we only show similar templates for the first 20, then the rest will be loaded based on the filter
  // this is to avoid refactoring template masonry
  const similarTemplates = useQuery({
    queryKey: ["similarTemplates", template.id],
    queryFn: async () => {
      const response = await apiClient.templates.getSimilar({
        params: { id: template.id },
        query: { limit: 20, offset: 0 },
      });

      return response.body.items;
    },
  });

  return (
    <>
      <h2 className="pb-4 text-center text-xl font-bold leading-7 text-neutral-50 sm:truncate sm:text-left sm:text-2xl sm:tracking-tight">
        {"More Like This"}
      </h2>

      <TemplateMasonry filter={filter} initialData={similarTemplates.data || []} />
    </>
  );
}

function computeInitialFilter(template: TemplateData): TemplateFilter {
  const tags = template.tags?.split(",") || [];

  for (const tag of tags) {
    if (templateTagsFilterMetadata.includes(tag as TemplateTagsFilter)) {
      return tag as TemplateTagsFilter;
    }
  }

  if (typeWithTemplate.includes(template.type as any)) {
    return template.type as (typeof typeWithTemplate)[number];
  }

  return "popular";
}
